export const INFO_TYPE = 'INFO_TYPE';
export const WARNING_TYPE = 'WARNING_TYPE';
export const SUCCESS_TYPE = 'SUCCESS_TYPE';
export const ERROR_TYPE = 'ERROR_TYPE';

export const DEFAULT_NOTIFICATION_TIMEOUT = 3000;
